import React, { useState, useEffect } from "react";
import prev from "./imgs/previous.png"
import next from "./imgs/next.png"

export default function Characters() {
  const [allCharacter, setAllCharacter] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedCharacter, setSelectedCharacter] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getCharacter = async (page, status = "", name = "") => {
    setLoading(true);
    const res = await fetch(`https://rickandmortyapi.com/api/character/?page=${page}&name=${name}&status=${status}`);
    const data = await res.json();
    const filteredData = data.results.filter(character => character.status);
    setAllCharacter(filteredData || []);
    setTotalPages(data.info?.pages || 0);
    setLoading(false);
  };
  useEffect(() => {
    getCharacter(currentPage, "", searchTerm);
  }, [currentPage, searchTerm]);

  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    event.preventDefault();
    setCurrentPage(1);
    getCharacter(1, "", term);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    setCurrentPage(1);
    getCharacter(1, "", searchTerm);
  };

  const handleStatusClick = (status) => {
    setSelectedStatus(status);
    setCurrentPage(1)
    getCharacter(1, status, searchTerm);
  };

  const handlePrev = () => {
    const prevPage = currentPage - 1;
    if (prevPage >= 1) {
      setCurrentPage(prevPage);
      getCharacter(prevPage, selectedStatus, searchTerm);
    }
  };

  const handleNext = () => {
    const nextPage = currentPage + 1;
    if (nextPage <= totalPages) {
      setCurrentPage(nextPage);
      getCharacter(nextPage, selectedStatus, searchTerm);
    }
  };

  const handleCharacterClick = (character) => {
    setSelectedCharacter(character);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCharacter(null);
  };

  const filteredCharacters = allCharacter.filter(character => {
    const matchesSearch = character.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = selectedStatus ? character.status.toLowerCase() === selectedStatus.toLowerCase() : true;
    return matchesSearch && matchesStatus;
  }).sort((a, b) => a.name.localeCompare(b.name));

  useEffect(() => {
    if (isModalOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [isModalOpen]);

  return (
    <div className="character-container">
      <h2 className="title">Rick and Morty</h2>
      <h4 className="route">Characters</h4>
      <form onSubmit={handleSearchSubmit}>
        <input
          className="search"
          type="search"
          placeholder="Search"
          autoComplete={true}
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <button type="submit" className="search-button">Search</button>
      </form>
      <div className="status-btns">
        <button className="none-btn" onClick={() => handleStatusClick("")}>All {allCharacter.length}</button>
        <button className="alive-btn" onClick={() => handleStatusClick("alive")}>Alive {filteredCharacters.filter(character => character.status === "Alive").length}</button>
        <button className="dead-btn" onClick={() => handleStatusClick("dead")}>Dead {allCharacter.filter(character => character.status === "Dead").length}</button>
        <button className="unknown-btn" onClick={() => handleStatusClick("unknown")}>Unknown {allCharacter.filter(character => character.status === "unknown").length}</button>
      </div>
      <div className="character-contain">
        {loading ? (
          <div className="loader"></div>
        ) : filteredCharacters.length === 0 ? (
          <div className="no-characters">No such character as "{searchTerm}".</div>
        ) : (
          filteredCharacters.map(character => (
            <div className="Characters" key={character.id} onClick={() => handleCharacterClick(character)}>
              <img className="character-img" src={character.image} alt={character.name} />
              <div className="character-info">
                <h4 className="character-name">{character.name}</h4>
                <p className="character-specie">
                  <p className={character.status === "Alive" ? "live" : character.status === "Dead" ? "dead" : "unknown"}></p>
                  {character.status} - {character.species}
                </p>
                <span className="character-gender">{character.gender}</span>
              </div>
            </div>
          ))
        )}
      </div>
      <div className="buttons">
        <img className="button" src={prev} alt="previous" onClick={handlePrev} />
        <div className="display">{currentPage}</div>
        <img className="button" src={next} alt="next" onClick={handleNext} />
      </div>
      {isModalOpen && (
        <div className="modal-content">
          <p className="close" onClick={closeModal}>&times;</p>
          {selectedCharacter && (
            <div className="modal-info">
              <img className="modal-img" src={selectedCharacter.image} alt={selectedCharacter.name} />
              <div className="modal">
                <h2 className="modal-name bold">Name: <span className="thin">{selectedCharacter.name}</span></h2>
                <p className="modal-status bold">Status: <span className="thin">{selectedCharacter.status}</span></p>
                <p className="modal-type bold">Type: <span className="thin">{selectedCharacter.type || "Unknown"}</span></p>
                <p className="modal-gender bold">Gender: <span className="thin">{selectedCharacter.gender}</span></p>
                <p className="modal-species bold">Species: <span className="thin">{selectedCharacter.species}</span></p>
                <p className="modal-episode bold">Episode Appeared In: <span className="thin">{selectedCharacter.episode.length}</span></p>
                <p className="modal-origin bold">First seen in: <span className="thin">{selectedCharacter.origin?.name}</span></p>
                <p className="modal-location bold">Last known location: <span className="thin">{selectedCharacter.location?.name}</span></p>
              </div>
              {/* Add more details as needed */}
            </div>
          )}
        </div>
      )}
    </div>
  );
}